import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  OnInit,
  ChangeDetectorRef,
  SimpleChanges,
} from '@angular/core';
import {
  AccountWalletDetails,
  DefaultWalletBalance,
  WalletCurrency,
  WalletTopUp,
} from '@cai-services';

@Component({
  selector: 'kt-wallet-topup-currency',
  templateUrl: './wallet-topup-currency.component.html',
  styleUrls: ['./wallet-topup-currency.component.scss'],
  standalone: false,
})
export class WalletTopupCurrencyComponent implements OnInit, OnChanges {
  @Input() walletDetails: AccountWalletDetails = new AccountWalletDetails();
  @Input() walletTopUp: WalletTopUp;
  @Input('currencies') extraCurrency: Array<WalletCurrency> = [];
  @Output() currencyChanged = new EventEmitter();
  @Output() onFocus = new EventEmitter();
  supportedCurrencyCodes = [];
  mappedExtraCurrencies = [];

  constructor(private cdr: ChangeDetectorRef) {
    if (!this.walletDetails.balances) {
      this.walletDetails.balances = new Array<DefaultWalletBalance>();
    }
  }

  ngOnInit(): void {
    if (this.walletDetails?.default_currency && !this.walletTopUp?.currency) {
      if (this.walletDetails.default_currency === 'UGX') {
        const alternateCurrency = this.walletsCurrencies?.find(
          (cur) => cur.currency !== 'UGX',
        );
        this.onSelectCurrency({ currency: alternateCurrency });
      } else {
        this.onSelectCurrency({
          currency: this.walletDetails.default_currency,
        });
      }
    }
    this.supportedCurrencyCodes = this.extraCurrency.map(
      (currency) => currency.code,
    );

    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('extraCurrency')) {
      this.mappedExtraCurrencies = this.currencyList.map((currency) => ({
        value: currency.code,
        currency: currency.code,
        label: currency.name,
      }));
      this.cdr.detectChanges();
    }
    this.supportedCurrencyCodes = this.extraCurrency.map(
      (currency) => currency.code,
    );

    if (this.walletDetails?.default_currency && !this.walletTopUp?.currency) {
      if (this.walletDetails.default_currency === 'UGX') {
        const alternateCurrency = this.walletsCurrencies?.find(
          (cur) => cur.currency !== 'UGX',
        );

        this.onSelectCurrency({ currency: alternateCurrency?.currency });
      } else {
        this.onSelectCurrency({
          currency: this.walletDetails.default_currency,
        });
      }
    }
  }

  onSelectCurrency(currency: any): void {
    if (!currency?.currency) {
      return;
    }
    this.walletTopUp.currency = currency.currency;
    this.currencyChanged.emit();
  }

  get walletsCurrencies() {
    return this.walletDetails?.balances.filter(
      (currency) =>
        this.supportedCurrencyCodes?.includes(currency?.currency) &&
        currency?.currency !== 'UGX',
    );
  }

  get currencyList() {
    if (!this.walletDetails) {
      return [];
    }
    return this.extraCurrency.filter((currency) =>
      this.walletDetails.balances.every(
        (ownCurrency) => ownCurrency.currency != currency.code,
      ),
    );
  }
}
